module.exports = __webpack_public_path__ + "static/diyanet5-0f1abf062f6312b1a0c561a539cc2d0e.png";